import { computed, watch } from "vue";
import { useStore } from "vuex";

export function useDarkMode() {
  const store = useStore();

  const isDarkMode = computed(() => store.getters["darkMode/isDarkMode"]);

  const themeClass = computed(() =>
    isDarkMode.value ? "dark-mode" : "light-mode"
  );

  watch(
    isDarkMode,
    (on) => {
      document.documentElement.classList.toggle("dark-mode", on);
    },
    { immediate: true }
  );

  function toggleDarkMode() {
    store.commit("darkMode/toggleDarkMode");
  }

  return {
    isDarkMode,
    themeClass,
    toggleDarkMode,
  };
}
